import React, {FC, memo, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import FormCode from "../../component/formCode/FormCode";
import {IToken} from "../../store/sliceToken";
import {useSelector} from "react-redux";
import {IRootState} from "../../store/configureStore";
import MainLabel from "../../component/mainLabel/MainLabel";
import {AuthContainer, Border, Container} from "../auth/login/LoginStyle";

const FormCodePage: FC = () => {

    const token: IToken = useSelector((state: IRootState) => state.token)
    const nav = useNavigate();

    useEffect(() => {
        if (token.verification == null) {
            nav(-1)
        }
    }, [])

    return (
        <Container as={"main"}>
            {/*<Col as={"section"} xl={4} lg={4} md={6} sm={8} xs={9} style={{justifySelf: "center"}}>*/}
            <AuthContainer>
                <Border>
                    <MainLabel/>
                    <FormCode token={token} rollback={() => nav(-1)}/>
                </Border>
            </AuthContainer>
            {/*</Col>*/}
        </Container>
    )
}

export default memo(FormCodePage);
